import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { useModal } from 'src/hooks/useModal';
import { I18nContext } from 'src/stores/I18n';
import { Presenter } from './Presenter';

export const AlcoholConfirmModal = () => {
  const { isVisible, setIsVisible } = useModal('alcoholConfirmModal');
  const localeResources = useContext(I18nContext);
  const { locale } = useRouter();

  if (!isVisible) return null;

  return (
    <Presenter
      title={localeResources.products.alcohol.confirm}
      closeModal={() => setIsVisible(false)}
      imageSrc={`/kaimono/images/products/alcohol/${locale}/alcohol.webp`}
      regardingSales={localeResources.products.alcohol.regardingSales}
      regardingSalesDesc={localeResources.products.alcohol.regardingSalesDesc}
      howToConfirm={localeResources.products.alcohol.howToConfirm}
    />
  );
};
